import { CostosPlataformaService } from "../../generated/grpc/plataforma_costos_pb";
import { ServiceDeleteBase } from "../base/ServiceDeleteBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";
import { CostoAgriculturaListService } from "./CostoAgriculturaListService";

/** Baja de tramos de DATA AG agricultura; la saca del listado en memoria. */
export class CostoAgriculturaDeleteService extends ServiceDeleteBase {
  static readonly instance = new CostoAgriculturaDeleteService();
  private constructor() { super(); }

  protected readonly cache = CostoAgriculturaListService.instance;

  /** gRPC-Web (`EliminarAgricultura`): baja lógica; `NotFoundError` si no existe. */
  protected async sendDelete(id: string): Promise<void> {
    await grpcCall(() => grpcClient(CostosPlataformaService).eliminarAgricultura({ id }));
  }
}
